import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v2/position', { params });
  },
  create(data) {
    return axios.post('/v2/position/create', data);
  },
  detail(id) {
    return axios.get(`/v2/position/detail/${id}`);
  },
  update(id, params) {
    return axios.put(`/v2/position/update/${id}`, params);
  },
  delete(id) {
    return axios.delete(`/v2/position/delete/${id}`);
  }
};
